<mat-card>
  <img *ngIf="imageUrl" class="imageCover" mat-card-image [src]="imageUrl" (click)="view()">
  <img *ngIf="!imageUrl" class="imageCover" mat-card-image
    src="https://png.pngtree.com/png-vector/20191218/ourmid/pngtree-coming-soon-logo-vector-template-design-illustration-png-image_2091063.jpg">

  <div *ngIf="haveFavorite">
    <img *ngIf="!isFavorite" src="../../../../assets/star-white.png" width="20px" height="20px"
      style="position: absolute; top: 10px; right: 10px;" (click)="changeFaverite()">
    <img *ngIf="isFavorite" src="../../../../assets/star.png" width="20px" height="20px"
      style="position: absolute; top: 10px; right: 10px;" (click)="changeFaverite()">
  </div>

  <mat-card-content *ngIf="title" (click)="view()">
    <h2 class="text-center cut-text" style="font-size: 162.5% !important; line-height: 1.15;">{{ title }}</h2>
  </mat-card-content>

  <mat-card-footer *ngIf="teacherName" (click)="view()">
    <div class="container">
      <span class="row name">
        <p style="margin: 0;">
          {{ teacherName }}
        </p>
      </span>

      <span *ngIf="isPremium" class="row price">
        <span *ngIf="premiumPrice > 0">
          <img src="../../../../assets/crown.png" width="20px" height="20px"
            style="margin-right: 5px; margin-top: -5px; max-width: 20px; display: inline-block;">
          <h5 style="display: inline-block;"><b>{{ premiumPrice | number }} ฿</b></h5>
        </span>
        <span *ngIf="premiumPrice === 0">
          <img src="../../../../assets/crown.png" width="20px" height="20px"
            style="margin-right: 5px; margin-top: -5px; max-width: 20px; display: inline-block;">
          <h5 style="display: inline-block;"><b>ฟรี</b></h5>
        </span>
      </span>
      <span *ngIf="!isPremium" class="row price">
        <h5 *ngIf="price> 0"><b>{{ price | number }} ฿</b></h5>
        <h5 *ngIf="price === 0"><b>ฟรี</b></h5>
      </span>
    </div>
  </mat-card-footer>
</mat-card>
